import { useLazyRef } from '@cocoonspace/shared/hooks/use-lazy-ref.hook'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, type StripeElementsOptions } from '@stripe/stripe-js'

import { PaymentProvider } from '~/domains/payments/providers/payment.provider'
import { useStripe } from '~/lib/stripe'

interface StripeProviderProps {
	children: any
}

const options: StripeElementsOptions = {
	locale: 'fr',
}

export const StripeProvider = ({ children }: StripeProviderProps) => {
	const stripePromiseRef = useLazyRef(() =>
		loadStripe(process.env.NEXT_PUBLIC_STRIPE_PK || ''),
	)

	return (
		<Elements
			options={options}
			stripe={stripePromiseRef.current}
		>
			<PaymentProvider service={useStripe}>{children}</PaymentProvider>
		</Elements>
	)
}
